var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setting-container"},[_c('NavSidebar'),_c('UserSettingForm',{attrs:{"initialUserData":_vm.userData,"isProcessing":_vm.isProcessing},on:{"after-submit":_vm.handleAfterSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }